import { render, staticRenderFns } from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=template&id=8de904e2&scoped=true"
import script from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=script&lang=ts"
export * from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=script&lang=ts"
import style0 from "./MtsTakipHazirlaFormBetaWizard.vue?vue&type=style&index=0&id=8de904e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de904e2",
  null
  
)

export default component.exports